// @ts-nocheck
import React from 'react';

export interface PackageTypeRowProps {
  game: any;
  style: React.CSSProperties;
}

function PackageTypeRow({ game, style }: PackageTypeRowProps) {
  return (
    <div className="grid-empty" style={style}>
      <span>{game.isSKU ? game.packageType : ''}</span>
    </div>
  );
}

export default PackageTypeRow;
